import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useAppAllowMobile = defineStore('appAllowMobile', () => {
  const mobileAllowed = ref(false);
  const allowMobile = () => { mobileAllowed.value = true; };
  return { mobileAllowed, allowMobile };
});
